import api from "./Api";

class UsuarioDadoService {
  GetUsuarioDado(payload) {
    return api.get("/v1/usuariodado/" + payload).then((response) => {
      return response.data;
    });
  }

  PostUsuarioDado(payload) {
    return api.post("/v1/usuariodado/", payload).then((response) => {
      return response.data;
    });
  }

  PutUsuarioDado(payload) {
    return api.put("/v1/usuariodado/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteUsuarioDado(payload) {
    return api.delete("/v1/usuariodado/" + payload).then((response) => {
      return response.data;
    });
  }

  GetUsuarioDadoOData(payload) {
    return api.get("/OData/usuariodado" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new UsuarioDadoService();
